import { useContext } from 'react'

import { LoadingContext } from '@/contexts/loading'

interface UseLoadingProps {
  loading: boolean
  showLoading: () => void
  hideLoading: () => void
}

export const useLoading = (): UseLoadingProps => {
  const { loading, setLoading } = useContext(LoadingContext)

  const showLoading = () => {
    setLoading(true)
  }

  const hideLoading = () => {
    setLoading(false)
  }

  return {
    loading,
    showLoading,
    hideLoading
  }
}
